import {Injectable} from "@angular/core";
import {SecondFactorAuthRegistrationModel} from "./second-factor-auth-registration-model";
import {SecondFactorAuthUserInfoModel} from "./second-factor-auth-user-info-model";

@Injectable({
  providedIn: 'root'
})
export class SecondFactorAuthPageService {

  constructor() {
  }

  TWO_FA_ROOT = '/_auth/2fa'

  async factorsInfo() {
    const response = await this.executeJsonRequest('GET', `${this.TWO_FA_ROOT}/factors`);
    if (!response?.ok) {
      throw Error();
    }
    return await response.json() as SecondFactorAuthUserInfoModel
  }

  async submitChallenge(factorId: string, challengeValue: string, rememberMe: boolean) {
    const response = await this.executeJsonRequest('POST', `${this.TWO_FA_ROOT}/factors/${factorId}/challenge_verification`, {
      challenge: challengeValue,
      rememberMe: rememberMe
    });
    if (!response.ok) {
      return await response.json() as {isSuccess: Boolean, attemptsLeft: number | null};
    }
  }

  async registerFactor(type: string) {
    const response = await this.executeJsonRequest('POST', `${this.TWO_FA_ROOT}/factors`, {type: type});
    if (response.ok) {
      return await response.json() as SecondFactorAuthRegistrationModel;
    }
    throw Error();
  }

  private async executeJsonRequest(method: string, path: string, body?: any) {
    return await fetch(path, {
        method: method,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }
    ).then((response: Response) => {
      // If 2FA session expired response will be a 302 to /login
      if (response.redirected) {
        (window as any).Navigate.showLoggedOutInfo();
        return;
      }
      return response;
    })
  }
}
